import React from 'react'
import update from 'immutability-helper';
import { browserHistory } from 'react-router'
import { modal } from '../../../core/utilities/modal'
import THREE from 'particlespace-graphics-engine'
import CanvasComponent from '../../../components/Graphics/CanvasComponent'
import BuildingGroupsSelect from '../../../components/Buildings/BuildingGroupsSelect'
import NumericSelect from '../../../helpers/General/NumericSelect'
import FloorPlanList from '../../../components/FloorPlans/FloorPlanList'
import BuildingTemplatesGUI from '../../../components/Buildings/BuildingTemplatesGUI'
import UnitedStatesSelect from '../../../helpers/General/UnitedStatesSelect';
import PropertiesSelect from '../../../components/Listings/PropertiesSelect.jsx';
import {newBuilding} from '../../../core/controllers/NewBuilding'
import {floorPlanRenderer} from '../../../core/graphic_engine/controllers/FloorPlanRenderer';
import {property} from '../../../core/controllers/Property';
import {user} from '../../../core/controllers/user';

export default class BuildingOverviewTemplate extends React.Component { 
    constructor(props) {
        super(props);

        this.state = {
            currentStep: {
                stepNum: 1// there are currently 4 steps.
            },
            newBuildingData: {
                name: "",
                building_group_id: 0,
                property_id: 0
            },
            totalSpaces: 0,
            buildingFloorAmount: 0,
            floorPlanID: 0,
            templateID: 0,
            buildingTemplates: null,
            allStepsCompleted: false,
            saved: false
        }
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.currentStep.stepNum == 3 && nextState.buildingTemplates == null) {
            this.getBuildingTemplates(nextState);
        }
    }
    // related to binding of building data
    handleNameChange(e){
        this.setState({
            newBuildingData: update(this.state.newBuildingData, {
                name: {$set: e.target.value
                }}
            )
        });
    }

    handleGroupSelect(e) {
        this.setState({
            newBuildingData: update(this.state.newBuildingData, {
                building_group_id: {$set: e.target.value
                }}
            )
        });
    }

    handlePropertyChange(e) {
        var self = this;
        var value = e.target.value;
        if (value == 0) {
            self.setState({
                newBuildingData: update(self.state.newBuildingData, {
                    property_id: {$set: value
                    }}
                ),
                selectedProperty: null
            });
        } else {
            property.getProperty(value, function(response) {
                self.setState({
                    newBuildingData: update(self.state.newBuildingData, {
                        property_id: {$set: value
                        }}
                    ),
                    selectedProperty: response.data
                });
            });
        }
    }

    // end


    // related to structure of building

    getBuildingTemplates(nextState) {
        var self = this;
        // now lets get our related building templates that match step 1 and 2 criteria
        newBuilding.getBuildingTemplates(nextState.floorPlanID, nextState.buildingFloorAmount, function(data){
            self.setState({
                buildingTemplates: data
            })
        });
    }
    

    didSelectLayout(floorPlanID) {
        this.setState({
            currentStep: {
                stepNum: 2
            },
            floorPlanID: floorPlanID
        });
    }

    numFloorsChange(e) {
        this.setState({
            buildingFloorAmount: e.target.value,
            buildingTemplates: null, // reset data
            currentStep: {
                stepNum: this.state.currentStep.stepNum + 1
            }
        });
    }

    didSelectTemplate(templateID, totalSpaces) {
        if(templateID === undefined) {
            templateID = 0; // blank template
        }

        this.setState({
            allStepsCompleted: true,
            templateID: templateID,
            totalSpaces: totalSpaces
        });
    }

    stepClicked(count) {
        if(this.state.currentStep.stepNum == count) { return; }

        this.setState({
            currentStep: {
                stepNum: count
            }
        });
    }

    // end

    saveBuilding() {
        const name = this.state.newBuildingData.name;
        if(name == '' || typeof name == 'undefined') {
            modal.showInfo("You need to enter a name for this building.", "danger", "top", "center");
            return;
        }

        newBuilding.saveBuilding(this);
    }

    render(){
        const floorPlanData = newBuilding.buildingFloorPlans;
        const templatesData = this.state.buildingTemplates;
        const templateID = this.state.templateID;
        const currentStep = this.state.currentStep;
        const stepsCompleted = this.state.allStepsCompleted;
        const buildingData = this.state.newBuildingData;
        const saved = this.state.saved;
        const property_id = this.state.newBuildingData.property_id;
        const selectedProperty = this.state.selectedProperty;
        return (
            <div class="col-md-12">
                <div class="row">
                    <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                </div>
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">Add a Building</span>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Building Information</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <form>
                                    <input type="hidden" class="building_id" name="building_id" value="" />
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Building Name</label>
                                                <input type="text" class="form-control building-info" name="title" placeholder="Enter the building title" id="title" value={buildingData.name} onChange={this.handleNameChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Select a property</label>
                                                <PropertiesSelect columnSize={0} sortID={property_id} title="" onChange={this.handlePropertyChange.bind(this)} />
                                            </div>
                                        </div>
                                    </div>
                                    { selectedProperty != null && (
                                    <div class="row">
                                        <div class="col-md-10 col-md-offset-1">
                                            { selectedProperty.photo == null ? (
                                            <div class="property-photo">
                                                <p>No cover image.</p>
                                            </div>
                                            ) : (
                                            <div class="property-photo">
                                                <img src={selectedProperty.photo.url} width="100%" />
                                            </div>
                                            )}
                                            <div class="header">
                                                <h4 class="title">{selectedProperty.details.property_name}</h4>
                                                <p class="category">{selectedProperty.details.property_address}<br/>{selectedProperty.details.property_city} {selectedProperty.details.property_state}, {selectedProperty.details.property_zip}</p>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title"><i class="fa fa-wrench"></i> Structure</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <div class="header">
                                    <label for="floor_plan" class="step-label" onClick={this.stepClicked.bind(this, 1)}>
                                        <span class="num">1</span> 
                                        <p>Select a Floor Plan</p>
                                    </label>
                                </div>
                                {currentStep.stepNum == 1 && (
                                    <FloorPlanList data={floorPlanData} activateLayout={this.didSelectLayout.bind(this)}/>
                                )}
                                <div class="header">
                                    <label for="floor_plan" class="step-label" onClick={this.stepClicked.bind(this, 2)}>
                                        <span class="num">2</span> 
                                        <p>How many floors does this building have?</p>
                                    </label>
                                </div>
                                {currentStep.stepNum == 2 && (
                                    <NumericSelect columnSize="12" title="" padding="0px" increment={25} numSelected={this.state.buildingFloorAmount} onChange={this.numFloorsChange.bind(this)}/>
                                )}
                                <div class="header">
                                    <label for="floor_plan" class="step-label" onClick={this.stepClicked.bind(this, 3)}>
                                        <span class="num">3</span> 
                                        <p>Prebuilt Building Templates</p>
                                    </label>
                                </div>
                                {currentStep.stepNum == 3 && (
                                    <BuildingTemplatesGUI templateID={templateID} data={templatesData} activateTemplate={this.didSelectTemplate.bind(this)}/>
                                )}
                                {(stepsCompleted == true && saved != true) && (
                                    <div class="row">
                                        <div class="col-sm-10">
                                            <button type="button" id="save-building" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.saveBuilding.bind(this)}>
                                            Save Building
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Building/New/New.jsx